<template>
  <Event ref="eventRef" :event="mappedEvent" @open-edit-component="show">
    <div class="font-bold">
      <table>
        <tbody>
          <tr>
            <td class="color white-space-nowrap">
              {{ t("components.issueModal.technicalPlace") }}
            </td>
            <td class="pl-3">
              {{ event.technicalPlace.path + " | " + event.technicalPlace.name }}
            </td>
          </tr>

          <tr v-if="event.repTime && event.repTime.length > 0">
            <td class="color white-space-nowrap">{{ t("components.issueModal.repTime") }}</td>
            <td class="pl-3">
              {{ formatDate(event.repTime[0]) }} <i class="fa fa-arrow-right fa-xs" />
              {{ formatDate(event.repTime[1]) }}
            </td>
          </tr>

          <tr>
            <td class="color white-space-nowrap">{{ t("components.issueModal.plannedTime") }}</td>
            <td class="pl-3">{{ event.plannedTime + " " + t("license.ih.ih.hour") }}</td>
          </tr>

          <tr>
            <td class="color white-space-nowrap">{{ t("components.issueModal.description") }}</td>
            <td class="pl-3 white-space-pre">{{ event.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <template #trailingHeaderAdditionsFront>
      <AttachmentBadge :files="mappedEvent.Folder?.files" class="inline" />
    </template>
    <template #editComponent>
      <IHMaintenanceModal
        ref="editComponent"
        :event="{ ...event, fileIds: event.Folder?.files.map((file) => file.id) ?? [] }"
      />
    </template>
  </Event>
</template>

<script setup lang="ts">
import { useTranslation } from "@/language/translation";

import { type PropType, computed, ref } from "vue";
import { DateTime } from "luxon";
import type { EventListEventFields_IHMaintenance_Fragment } from "@/graphql";
import Event from "@/components/event-action/event/EventComponent.vue";
import IHMaintenanceModal from "@/modules/ih/components/IHMaintenanceModal.vue";
import { LISA_DATE_SHORT } from "@/language/translation";
import AttachmentBadge from "@/components/badges/AttachmentBadge.vue";

const props = defineProps({
  event: {
    type: Object as PropType<EventListEventFields_IHMaintenance_Fragment>,
    required: true,
  },
});
const eventRef = ref<InstanceType<typeof Event>>();
const mappedEvent = computed(() => ({
  ...props.event,
}));

/**
 * Formats a date string to a localized date string.
 */
const formatDate = (value: string) => {
  return DateTime.fromISO(value).toLocaleString(LISA_DATE_SHORT);
};

/**
 * Shows the edit component.
 */
const editComponent = ref<null | InstanceType<typeof IHMaintenanceModal>>(null);
const show = () => {
  editComponent.value?.show();
};

defineExpose({
  eventRef,
});

const { t } = useTranslation();
</script>

<style lang="scss" scoped>
.color {
  color: #166b95;
}

table td {
  vertical-align: top;
}
</style>
